import { getApi, putApiWithoutId } from "../../Shared/Services/RestService";
import { TaxConfigRequest, TaxConfigResponse } from "../Types/TaxConfigType";

const BASE = "/admin/payment-tax";

/**
 * The current tax configuration.
 *
 * <p>A singleton, so there is no id and no per-row route - `PUT` to the collection is the save.
 */
export const getTaxConfig = () => {
  return getApi<TaxConfigResponse>(BASE);
};

export const saveTaxConfig = (payload: TaxConfigRequest) => {
  return putApiWithoutId<TaxConfigResponse>(BASE, payload);
};